import { useEffect, useMemo, useState } from "react";
import { Spinner } from "reactstrap";
import ProjectsService from "../Services/ProjectsService";
import ProjectModel from "../Models/ProjectModel";
import "react-datepicker/dist/react-datepicker.css";
import { useMsal } from "@azure/msal-react";
import { toast } from "react-toastify";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import DataTable from "../Components/DataTable";

const columnHelper = createColumnHelper<ProjectModel>();

const ProjectsWarehouse = () => {
  const { instance } = useMsal();

  const projectsService = useMemo(
    () => new ProjectsService(instance),
    [instance]
  );

  const [showLoadingSpinner, setShowLoadingSpinner] = useState<boolean>(true);
  const [projects, setProjects] = useState<ProjectModel[]>([]);

  useEffect(() => {
    async function loadProjects() {
      try {
        let projects = await projectsService.getProjectsForWarehouse();

        setProjects(projects);
        setShowLoadingSpinner(false);
      } catch (err) {
        toast.error("Fout bij het ophalen van de data.");
      }
    }

    loadProjects();
  }, []);

  const codeCol = columnHelper.accessor("code", {
    header: "Projectnr",
    cell: (props) => props.getValue(),
    size: 140,
  }) as ColumnDef<unknown, any>;

  const foremanCol = columnHelper.accessor("foremanName", {
    header: "Ploegleider",
    cell: (props) => {
      let dataHtml = null;

      const value = props.getValue();

      if (
        props.row.original.customForemanName !== undefined &&
        props.row.original.customForemanName !== null
      ) {
        dataHtml = <span>{props.row.original.customForemanName}</span>;
      } else if (value !== undefined && value !== null && value !== "") {
        dataHtml = <span>{value}</span>;
      }

      return dataHtml;
    },
    enableGlobalFilter: false,
  }) as ColumnDef<unknown, any>;

  const ownerCol = columnHelper.accessor("ownerName", {
    header: "Opvolger",
    cell: (props) => props.getValue(),
    enableGlobalFilter: false,
  }) as ColumnDef<unknown, any>;

  const allColumns = [codeCol, foremanCol, ownerCol];

  if (projects) {
    let table = null;

    if (showLoadingSpinner) {
      table = (
        <div className="d-flex justify-content-center">
          <Spinner type="grow" color="secondary" className="m-5" />
        </div>
      );
    } else {
      table = <DataTable data={projects} columns={allColumns} height="40vh" />;
    }

    return <div className="container-fluid">{table}</div>;
  }

  return <div className="container-fluid"></div>;
};

export default ProjectsWarehouse;
